import React from 'react';
import PropTypes from 'prop-types';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import third-party libraries
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';

// import form components
import TextInput from '../../../global/components/forms/TextInput.js.jsx';
import CourseModuleOptions from './CourseModuleOptions.js.jsx';

class ObjectListComparator extends Base {
  constructor(props) {
    super(props);
    this.state = {
      queryText: ''
      , isOpen: false
    }
    this._bind(
      '_addItem'
      , '_addAll'
      , '_moveDown'
      , '_moveUp'
      , '_moveToTop'
      , '_removeItem'
      , '_removeAll'
      , '_handleFormChange'
    )
  }

  _removeItem(index) {
    // remove from "items" list
    // console.log("REMOVE " + index);
    let selected = this.props.selected;
    selected.splice(index, 1);
    let event = {target: {name: this.props.name, value: this.props.selected} };
    this.props.change(event);
  }

  _removeAll() {
    let selected = this.props.selected
    selected.splice(0, selected.length)
    let event = {target: {name: this.props.name, value: this.props.selected} };
    this.props.change(event);
  }

  _addItem(index) {
    // console.log("ADD", index);
    const { queryText } = this.state;
    const { displayKey, items, filterable, selected, valueKey } = this.props;
    // filter items first
    let filteredItems = [];
    if(filterable) {
      filteredItems = _.filter(items, function(item) {
        let itemsString = "";
        itemsString += item[displayKey];
        itemsString = itemsString.replace(/[^a-zA-Z0-9]/g, '');
        return itemsString.toLowerCase().indexOf(queryText.toLowerCase()) > -1;
      });
    } else {
      filteredItems = items;
    }
    // add to "items" list
    let newSelected = selected;
    let unselectedItems = [];
    for(let i = 0; i < filteredItems.length; i++) {
      let isSelected = false;
      for(let j = 0; j < selected.length; j++) {
        if(filteredItems[i][valueKey] == selected[j]) {
          isSelected = true;
        }
      }
      if(!isSelected) {
        unselectedItems.push(filteredItems[i]);
      }
    }
    newSelected.push(unselectedItems[index][valueKey]);
    let event = {target: {name: this.props.name, value: newSelected} };
    this.props.change(event);
  }

  _addAll() {
    const { items, selected, valueKey } = this.props;
    let newSelected = selected 
    for (let i = 0; i < items.length; i++) {
      if(!newSelected.includes(items[i][valueKey])) {
        newSelected.push(items[i][valueKey])
      }
    }
    let event = {target: {name: this.props.name, value: newSelected} };
    this.props.change(event);
  }

  _moveUp(index) {
    if(index < 1) { return; }
    let newSelected = this.props.selected;
    let moveTarget = newSelected[index];
    newSelected[index] = newSelected[index - 1];
    newSelected[index - 1] = moveTarget;
    let changeEvent = {
      target: {
        name: this.props.name
        , value: newSelected
      }
    }
    this.props.change(changeEvent);
  }

  _moveDown(index) {
    // console.log("move down", index, this.props.selected.length);
    if(index >= this.props.selected.length - 1) { return; }
    let newSelected = this.props.selected;
    let moveTarget = newSelected[index];
    newSelected[index] = newSelected[index + 1];
    newSelected[index + 1] = moveTarget;
    let changeEvent = {
      target: {
        name: this.props.name
        , value: newSelected
      }
    }
    this.props.change(changeEvent);
  }

  _moveToTop(index) {
    if(index > 0) {
      let newSelected = this.props.selected; 
      let newTopMod = newSelected.splice(index, 1); 
      newSelected.unshift(newTopMod[0]); 
      let changeEvent = {
        target: {
          name: this.props.name
          , value: newSelected
        }
      }
      this.props.change(changeEvent); 
    }
  }

  _handleFormChange(e) {
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    this.setState(newState);
  }

  render() {
    // console.log("object list comparator rendering");
    const {
      addLabel
      , addRemoveAll
      , displayKey
      , filterable
      , tooltipText
      , items
      , label
      , name
      , removeLabel
      , reorderable
      , selected
      , selectedLabel
      , availableLabel
      , valueKey
    } = this.props;
    const { queryText, isOpen } = this.state;
    const tooltipId = Math.floor(Math.random()*16777215).toString(16);

    let filteredItems = [];
    if(filterable) {
      filteredItems = _.filter(items, function(item) {
        let itemsString = "";
        itemsString += item[displayKey];
        itemsString = itemsString.replace(/[^a-zA-Z0-9]/g, '');
        return itemsString.toLowerCase().indexOf(queryText.toLowerCase()) > -1;
      });
    } else {
      filteredItems = items;
    }

    let selectedItems = [];
    let unselectedItems = [];
    for(let i = 0; i < filteredItems.length; i++) {
      let isSelected = false;
      for(let j = 0; j < selected.length; j++) {
        if(filteredItems[i][valueKey] == selected[j]) {
          isSelected = true;
        }
      }
      if(!isSelected) {
        unselectedItems.push(filteredItems[i]);
      }
    }
    // order matters for selected items
    for(let i = 0; i < selected.length; i++) {
      for(let j = 0; j < filteredItems.length; j++) {
        if(selected[i] == filteredItems[j][valueKey]) {
          selectedItems.push(filteredItems[j]);
        }
      }
    }

    return (
      <div className="input-group">
        <label htmlFor="newItem">
        { label }
        { tooltipText ?
            <span>
              <sup><i className="far fa-info-circle" data-tip data-for={tooltipId} /></sup>
              <ReactTooltip
                aria-haspopup='true'
                className="yt-tooltip"
                id={tooltipId}
                place="top"
                type="dark"
              >
                <p>{tooltipText}</p>
              </ReactTooltip>
            </span>
          :
            null
        }
        </label>
        <div className="list-comparator-input">
          <div className="yt-row with-gutters">
            { filterable ?
                <div className="yt-col _100">
                  <TextInput
                    name="queryText"
                    label="Filter"
                    value={queryText}
                    change={this._handleFormChange}
                    placeholder="Filter"
                    required={false}
                  />
                </div>
              :
                <div className="yt-col _100"></div>
            }
          </div>
          <div className="yt-row with-gutters">
            <div className="yt-col _50">
              <div className="-label">{selectedLabel ? selectedLabel + ':': 'Selected:'}</div>
              { addRemoveAll ?
                <button
                  type="button"
                  className="yt-btn link info x-small"
                  onClick={()=> this._removeAll()}
                >
                  {removeLabel ? removeLabel : "Remove All"}
                </button>
                : null
              }
                
              <div className="-list-items">
                { selectedItems.map((item, i) => 
                  <CourseModuleOptions
                    item={item}
                    index={i}
                    reorderable={reorderable}
                    moveUp={this._moveUp}
                    moveDown={this._moveDown}
                    removeItem={this._removeItem}
                    moveToTop={this._moveToTop}
                    displayKey={displayKey}
                    selectedItems={selectedItems}
                  />
                )}
              </div>
            </div>
            <div className="yt-col _50">
              <div className="-label">{availableLabel ? availableLabel + ':' : 'Available:'}</div>
              { addRemoveAll ?
                <button
                  type="button"
                  className="yt-btn link info x-small"
                  onClick={()=> this._addAll()}
                >
                  {addLabel ? addLabel : 'Add All'}
                </button>
                : null
              }
              <div className="-list-items ">
                { unselectedItems.map((item, i) => {
                  return(<div key={i}  className="-item -right" onClick={() => this._addItem(i)}>
                    <i className="fa fa-arrow-circle-left" style={{marginRight: '10px', marginLeft: '5px'}}></i>
                    <p className="-text">
                      {"    " + item[displayKey]}
                    </p>
                  </div>)
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ObjectListComparator.propTypes = {
  change: PropTypes.func.isRequired
  , displayKey: PropTypes.string.isRequired // key to display on objects
  , filterable: PropTypes.bool
  , items: PropTypes.oneOfType([
    PropTypes.array
    , PropTypes.object
  ]).isRequired // all possible items
  , label: PropTypes.string
  , name: PropTypes.string.isRequired // name of field on parent to update
  , reorderable: PropTypes.bool
  , selected: PropTypes.arrayOf(PropTypes.string) // array of [valueKey's]
  , tooltipText: PropTypes.string
  , valueKey: PropTypes.string.isRequired // key to return as selected
}

ObjectListComparator.defaultProps = {
  filterable: false
  , items: []
  , label: ""
  , reorderable: false
}

export default ObjectListComparator;


// WEBPACK FOOTER //
// modules/course/components/CourseObjectListComparator.js.jsx